import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TitleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"title"}/>
}
